import React from 'react';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';

import HttpError from 'components/HttpError';

const withQuery = (Component) => {
    return function WithQueryComponent(props) {
        const {response} = props;

        if (response.loading) {
            return <LoadingOverlay />;
        }

        if (response.error) {
            return (
                <HttpError
                    statusCode={500}
                    message={response.error.message || 'Server error'}
                />
            );
        }

        return <Component {...props} />;
    };
};

export default withQuery;
